import React from 'react';
import CurrentWorkloadTable from './CurrentWorkloadTable';

const CurrentWorkloadSection = ({ data }) => {
  return (
    <CurrentWorkloadTable data={data} />
  );
}

export default CurrentWorkloadSection;